"use client";

import Dialog from "@mui/material/Dialog";
import CompleteProfileForm from "../(browse)/auth/CompleteProfileForm";
import { useLazySession } from "./useLazySession";

export function CompleteProfileCheck() {
  const { session, isAuthenticated } = useLazySession();

  const mustCompleteProfile = isAuthenticated && !session?.user?.name;

  if (!mustCompleteProfile || !session?.user?.id) {
    return <></>;
  }

  return (
    <Dialog open={true}>
      <CompleteProfileForm userId={session.user.id} />
    </Dialog>
  );
}
